import API_BASE_URL from '../config/api';

export async function getEntityFromRTDB(type, identifier) {
  try {
    const res = await fetch(`${API_BASE_URL}/api/v1/deeplink/${type}/${identifier}`);
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`Server error: ${res.status}`);
    const json = await res.json();
    return json.data || null;
  } catch (err) {
    console.error(`Failed to fetch ${type}/${identifier} from server:`, err);
    return null;
  }
}
